export default __webpack_public_path__ + "static/media/captainBadge.7dc8c043.svg";